import { orchestrator } from 'satcheljs';
import { deleteRequest } from '../services/deleteRequest';
import { getPremiumUser } from '../actions/getPremiumUser';
import { removeEmail } from '../actions/removeEmail';
import setIsRemovingEmailAddress from '../mutators/setIsRemovingEmailAddress';

const deleteUrl: string = 'ows/api/beta/PremiumUser';

export default orchestrator(removeEmail, async function removeEmail() {
    setIsRemovingEmailAddress(true);
    await deleteRequest(deleteUrl);
    getPremiumUser();
    setIsRemovingEmailAddress(false);
});
